import type { RetryOptions } from '../../types';
import { getShouldRetryBasedOnMaxRetries } from './getShouldRetryBasedOnMaxRetries';

export type GetShouldRetryParams = {
  retryOptions: RetryOptions;
  numberOfFailedAttempts: number;
  response: Response;
};

export const getShouldRetry = ({
  retryOptions,
  numberOfFailedAttempts,
  response,
}: GetShouldRetryParams): boolean => {
  if (retryOptions.getShouldRetry) {
    return retryOptions.getShouldRetry({ response, numberOfFailedAttempts });
  }

  return getShouldRetryBasedOnMaxRetries({
    maxRetries: retryOptions.maxRetries,
    numberOfFailedAttempts,
    response,
  });
};
